module.exports = __webpack_public_path__ + "img/luxury-homepage-content-overlay-infiniti.182b0e4f.png";